(function(){
  var root=document.querySelector('.vf');
  if(!root||root.dataset.on) return; root.dataset.on='1';
  var $=function(s){
        return root.querySelector('[data-'+s+']') || document.querySelector('.vf-buy [data-'+s+']');
      },
      $$=function(s){
        var a=[].slice.call(root.querySelectorAll('[data-'+s+']'));
        [].slice.call(document.querySelectorAll('.vf-buy [data-'+s+']')).forEach(function(e){ if(a.indexOf(e)<0) a.push(e); });
        return a;
      };

  var CFG=JSON.parse(root.querySelector('.vf-cfg').textContent);
  var VAR=CFG.variants;
  var I=CFG.i;
  var CORES=[],TAMS=[],LOCS=[],MAP={},POR={};
  VAR.forEach(function(v){
    var c=v.options[I.c],t=v.options[I.t],l=v.options[I.l];
    if(CORES.indexOf(c)<0)CORES.push(c);
    if(TAMS.indexOf(t)<0)TAMS.push(t);
    if(LOCS.indexOf(l)<0)LOCS.push(l);
    MAP[c+'|'+t+'|'+l]=v;
    var k=c+'|'+l; if(!POR[k]&&v.featured_image)POR[k]=v.featured_image.src;
  });

  var MED={};
  (CFG.medidas||'').split(String.fromCharCode(10)).forEach(function(ln){
    var p=ln.split('|'); if(p.length>=3) MED[p[0].trim()]=[p[1].trim(),p[2].trim()];
  });

  var TIERS=CFG.tiers;
  var LINHA_IDS=CFG.linha||[];
  var LBL='ADICIONAR';
  var ARTE=CFG.arte||'';

  /* v35: o tamanho NAO vem escolhido. Quem passa direto pela pagina levava P
     sem perceber e descobria o erro na entrega. Agora a escolha e consciente. */
  var st={c:CFG.sel[0],t:null,l:CFG.sel[2],q:1,i:0,busy:false};

  function brl(c){return 'R$ '+(c/100).toFixed(2).replace('.',',');}
  function img(c,l){return POR[c+'|'+l]||POR[c+'|'+LOCS[0]]||'';}
  function atual(){return MAP[st.c+'|'+st.t+'|'+st.l];}
  function pct(q){for(var i=0;i<TIERS.length;i++){if(TIERS[i].q&&q>=TIERS[i].q)return TIERS[i].p;}return 0;}

  /* ---- seletores ---- */
  var lc=$('locs');
  LOCS.forEach(function(l){
    var b=document.createElement('button'); b.type='button';
    b.className='vf-loc'+(l===st.l?' on':''); b.setAttribute('data-k',l);
    b.innerHTML='<img src="'+img(st.c,l)+'" alt=""><span>'+l+'</span>';
    b.onclick=function(){ st.l=l;
      lc.querySelectorAll('.vf-loc').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-k')===l);});
      pinta(); voltaInicio(); };
    lc.appendChild(b);
  });
  var cc=$('cores');
  CORES.forEach(function(c){
    var b=document.createElement('button'); b.type='button';
    b.className='vf-cor'+(c===st.c?' on':''); b.setAttribute('data-k',c);
    b.innerHTML='<i><img src="'+img(c,st.l)+'" alt=""></i><em>'+c+'</em>';
    b.onclick=function(){ st.c=c;
      cc.querySelectorAll('.vf-cor').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-k')===c);});
      lc.querySelectorAll('.vf-loc').forEach(function(x){x.querySelector('img').src=img(c,x.getAttribute('data-k'));});
      pinta(); voltaInicio(); };
    cc.appendChild(b);
  });
  var tc=$('tams');
  TAMS.forEach(function(t){
    var m=MED[t], b=document.createElement('button'); b.type='button';
    b.className='vf-tam'+(t===st.t?' on':''); b.setAttribute('data-k',t);
    b.innerHTML='<b>'+t+'</b>'+(m?'<em>'+m[0]+'×'+m[1]+' cm</em>':'');
    b.onclick=function(){ st.t=t;
      tc.querySelectorAll('.vf-tam').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-k')===t);});
      pinta(); };
    tc.appendChild(b);
  });

  var ladr=$('ladr');
  if(ladr&&TIERS){
    TIERS.slice().reverse().forEach(function(T){
      if(!T.q) return;
      var d=document.createElement('div'); d.className='vf-step'; d.setAttribute('data-q',T.q);
      d.innerHTML='<b>'+T.q+'+</b>'+brl(Math.round(CFG.preco*(1-T.p/100)))+' cada';
      ladr.appendChild(d);
    });
  }

  /* ---- galeria ---- */
  var sw=$('swipe'), dots=$('dots'), slides=sw.querySelectorAll('.vf-sl');
  var capEl=root.querySelector('.vf-cap [data-cap]');
  function legenda(i){
    if(i===0) return st.c+' · '+st.l;
    return (slides[i]&&slides[i].getAttribute('data-cap'))||'';
  }
  function voltaInicio(){
    try{ sw.scrollTo({left:0,behavior:'smooth'}); }catch(e){ sw.scrollLeft=0; }
    st.i=0; if(capEl) capEl.textContent=legenda(0);
    dots.querySelectorAll('.vf-dot').forEach(function(d,j){d.classList.toggle('on',j===0);});
  }
  slides.forEach(function(s,i){
    var d=document.createElement('span'); d.className='vf-dot'+(i===0?' on':''); dots.appendChild(d);
  });
  sw.addEventListener('scroll',function(){
    var i=Math.round(sw.scrollLeft/sw.clientWidth); if(i===st.i)return; st.i=i;
    if(capEl) capEl.textContent=legenda(i);
    dots.querySelectorAll('.vf-dot').forEach(function(d,j){d.classList.toggle('on',j===i);});
  });

  /* ---- lightbox ---- */
  var lb=$('lb'),lbi=$('lbimg'),lbc=$('lbcap'),lbNum=$('lbnum'),bPrev=$('lbp'),bNext=$('lbn'),bFecha=$('lbx'),G=[],gi=0;
  function pintaLb(){var it=G[gi]; if(!it)return;
    lbi.src=it.u; lbi.className=it.art?'art':''; lbc.innerHTML=it.c||'';
    lbNum.textContent=G.length>1?(gi+1)+' / '+G.length:''; lbNum.style.display=G.length>1?'':'none';
    bPrev.hidden=bNext.hidden=G.length<2;}
  function abre(l,i){G=l;gi=i||0;pintaLb();lb.classList.add('on');document.body.style.overflow='hidden';}
  function fecha(){lb.classList.remove('on');document.body.style.overflow='';}
  function anda(d){gi=(gi+d+G.length)%G.length;pintaLb();}
  bPrev.onclick=function(e){e.stopPropagation();anda(-1);};
  bNext.onclick=function(e){e.stopPropagation();anda(1);};
  bFecha.onclick=fecha;
  lb.onclick=function(e){if(e.target===lb||e.target.tagName==='FIGURE')fecha();};
  document.addEventListener('keydown',function(e){
    if(!lb.classList.contains('on'))return;
    if(e.key==='Escape')fecha(); if(e.key==='ArrowLeft')anda(-1); if(e.key==='ArrowRight')anda(1);});
  var tx=0;
  lb.addEventListener('touchstart',function(e){tx=e.touches[0].clientX;},{passive:true});
  lb.addEventListener('touchend',function(e){var d=e.changedTouches[0].clientX-tx;if(Math.abs(d)>50)anda(d<0?1:-1);},{passive:true});

  sw.addEventListener('click',function(e){
    if(e.target.tagName!=='IMG')return;
    var l=[]; slides.forEach(function(s){var im=s.querySelector('img'); if(im) l.push({u:im.src,c:s.getAttribute('data-cap'),art:s.classList.contains('card')});});
    abre(l, Math.max(0,st.i));
  });
  $$('fotos').forEach(function(el){
    var l=[]; el.querySelectorAll('img').forEach(function(im){l.push({u:im.src,c:im.alt});});
    el.querySelectorAll('img').forEach(function(im,i){ im.onclick=function(){abre(l,i);}; });
  });
  var va=$('verarte');
  if(va&&ARTE) va.onclick=function(){ abre([{u:ARTE,art:true,c:'<b class="vf-t">'+CFG.titulo+'</b><br>Arte original De Volta às Raízes. É exatamente esse desenho que vai impresso na peça.'}],0); };

  /* ---- botões ---- */
  var anc=$('anc');
  if(anc) anc.onclick=function(){
    var d=$('det')||document.querySelector('[data-vft]');
    if(d) d.scrollIntoView({behavior:'smooth'});
  };
  var como=$('como');
  if(como) como.onclick=function(){ var dg=$('diag'); if(dg) dg.classList.toggle('on'); };
  var exp=$('exp'); if(exp) exp.onclick=function(){
    var p=$('pane'); p.classList.toggle('on');
    exp.textContent=p.classList.contains('on')?'↑ recolher':'Por que ela é premium, na prática →';
  };
  $$('step').forEach(function(b){ b.onclick=function(){
    st.q=Math.max(1,Math.min(20,st.q+parseInt(b.getAttribute('data-step'),10))); pinta(); }; });

  var buy=root.querySelector('.vf-buy'), buyPai=buy?buy.parentElement:null;
  function posicionaBarra(){
    if(!buy) return;
    if(innerWidth<900){
      if(buy.parentElement!==document.body){ document.body.appendChild(buy); }
    }else if(buyPai && buy.parentElement===document.body){
      buyPai.appendChild(buy);
    }
  }
  /* Ao mover a barra para o body ela sai de dentro de .vf e perde as variaveis
     de cor (--txt, --mut, --line), que ficam pretas sobre fundo quase preto.
     Levamos os tokens junto com o elemento. */
  function levaTokens(){
    if(!buy||!root) return;
    var cs=getComputedStyle(root);
    ['--acc','--mut','--line','--txt','--bg','--acc14','--acc35'].forEach(function(n){
      var v=cs.getPropertyValue(n);
      if(v && v.trim()) buy.style.setProperty(n, v.trim());
    });
  }
  function mostraResumo(){
    var r=document.querySelector('.vf-buy .vf-res');
    if(r) r.style.display='block';
  }
  levaTokens(); posicionaBarra(); mostraResumo();
  addEventListener('resize',function(){ posicionaBarra(); mostraResumo(); });

  /* ---- aviso do botao ----
     Antes, quando a Shopify recusava a adicao ou a rede engasgava, o botao
     simplesmente nao fazia nada: nenhuma mensagem, nenhum sinal. Para quem
     esta comprando isso parece a pagina travada, e a pessoa clica de novo.
     Agora todo caminho de falha solta a trava e diz o que houve. */
  var aviso=null, avisoRelogio=null;
  (function(){
    var e=document.createElement('style');
    e.textContent='.vf-aviso{display:none;width:100%;order:9;margin-top:8px;padding:9px 11px;border-radius:10px;'+
      'background:rgba(232,120,90,.14);border:1px solid rgba(232,120,90,.5);color:#f0c9bb;'+
      'font-size:12px;line-height:1.45}.vf-aviso.on{display:block}';
    document.head.appendChild(e);
  })();
  function avisa(msg){
    if(!aviso){
      aviso=document.createElement('div');
      aviso.className='vf-aviso';
      (buy||root).appendChild(aviso);
    }
    aviso.textContent=msg;
    aviso.classList.add('on');
    clearTimeout(avisoRelogio);
    avisoRelogio=setTimeout(function(){ if(aviso) aviso.classList.remove('on'); }, 7000);
  }
  function limpaAviso(){ if(aviso) aviso.classList.remove('on'); }

  var add=$('add');
  function pedeTamanho(){
    var b=$('blktam'); if(!b) return;
    b.classList.add('pede');
    var av=$('avisotam'); if(av) av.classList.add('on');
    try{ b.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){ b.scrollIntoView(); }
    b.classList.remove('pisca'); void b.offsetWidth; b.classList.add('pisca');
  }
  function abreGaveta(){
    try{ document.dispatchEvent(new CustomEvent('cart:open')); return true; }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('cart-drawer:open')); return true; }catch(e){}
    var d=document.getElementById('CartDrawer');
    if(d && typeof d.showModal==='function' && !d.open){ try{ d.showModal(); return true; }catch(e){} }
    return false;
  }
  function sincronizaCarrinho(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var n=0; cart.items.forEach(function(it){ if(LINHA_IDS.indexOf(it.product_id)>=0) n+=it.quantity; });
        noCarrinho=n;
        var b=document.querySelector('.cart-bubble__text-count');
        if(b) b.textContent=cart.item_count;
        var bb=document.querySelector('.cart-bubble');
        if(bb) bb.removeAttribute('hidden');
        var dc=document.querySelector('.drawer-count-ajax');
        if(dc) dc.textContent=cart.item_count;
        pinta();
        return cart;
      }).catch(function(){});
  }
  add.onclick=function(){
    if(!st.t){ pedeTamanho(); return; }
    var v=atual(); if(!v||st.busy) return;
    limpaAviso();
    st.busy=true; add.setAttribute('disabled','');
    var solto=false, relogio=null;
    function solta(){
      if(solto) return; solto=true;
      clearTimeout(relogio);
      st.busy=false; add.removeAttribute('disabled');
    }
    function falha(msg){
      solta();
      avisa(msg||'Não deu para adicionar agora. Toque de novo.');
    }
    /* rede lenta nao pode deixar o botao morto para sempre */
    relogio=setTimeout(function(){
      falha('A conexão demorou demais. Toque em ADICIONAR de novo.');
    }, 12000);

    fetch('/cart/add.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:v.id,quantity:st.q}],sections:'cart-drawer-custom',sections_url:location.pathname})})
      .then(function(r){ return r.json().catch(function(){ return {status:r.status}; }); })
      .then(function(state){
        if(solto) return;
        if(state && state.status && state.status>=400){
          falha(state.description||state.message||'Essa combinação não pôde ser adicionada.');
          return;
        }
        var pintou=false;
        if(window.CartV10 && typeof window.CartV10.renderDrawer==='function' && state && state.sections){
          try{ window.CartV10.renderDrawer(state); pintou=true; }catch(e){}
        }
        if(!pintou) abreGaveta();
        solta();
        sincronizaCarrinho();
      })
      .catch(function(){ falha('Sem conexão com a loja. Toque de novo.'); });
  };

  /* ---- pintura ---- */
  var noCarrinho=0;
  function pinta(){
    var v=atual(), m=MED[st.t];
    var h=$('hero'), novo=img(st.c,st.l); if(h&&novo) h.src=novo;
    $('lcor').textContent=st.c;
    var lt=$('ltam'); if(lt) lt.textContent=st.t||'';
    var ml=$('medl'); if(ml) ml.innerHTML=m?('<b>'+m[0]+' cm</b> de altura por <b>'+m[1]+' cm</b> de largura.'):'';
    var qt=$('qtam');
    if(qt) qt.innerHTML=st.t?(': <b>'+st.t+'</b>, peça deitada em cm'):'escolha o seu, peça deitada em cm';
    $('res').textContent=st.c+' · '+st.l+(st.t?(' · '+st.t):'');
    $('qty').textContent=st.q;
    if(!st.t){
      add.removeAttribute('disabled');
      add.textContent='ESCOLHA O TAMANHO';
      add.classList.add('vf-pede');
      return;
    }
    /* escolheu: apaga o pedido de tamanho (borda laranja e aviso) */
    var bt=$('blktam'); if(bt) bt.classList.remove('pede','pisca');
    var at=$('avisotam'); if(at) at.classList.remove('on');
    add.classList.remove('vf-pede');
    if(!v){ add.setAttribute('disabled',''); add.textContent='Indisponível'; return; }
    if(!st.busy) add.removeAttribute('disabled');
    var total=noCarrinho+st.q, p=pct(total), un=Math.round(v.price*(1-p/100));
    $('pz').innerHTML=brl(v.price);
    var rp=$('resp'); if(rp) rp.textContent=brl(un*st.q);
    add.innerHTML=LBL+' — '+brl(un*st.q)+(p?'<small>'+brl(un)+' cada · '+p+'% off</small>':'');
    if(ladr){
      ladr.querySelectorAll('.vf-step').forEach(function(s){ s.classList.toggle('hit', total>=parseInt(s.getAttribute('data-q'),10)); });
      var prox=null,ant=0;
      for(var k=TIERS.length-1;k>=0;k--){ if(TIERS[k].q&&total<TIERS[k].q){prox=TIERS[k];break;} if(TIERS[k].q)ant=TIERS[k].q; }
      if(prox){
        $('fill').style.width=Math.max(0,Math.min(100,((total-ant)/(prox.q-ant))*100))+'%';
        $('ladm').innerHTML='Leve mais <b>'+(prox.q-total)+'</b> e cada camiseta sai por <b>'+brl(Math.round(v.price*(1-prox.p/100)))+'</b>.';
      }else{
        $('fill').style.width='100%';
        $('ladm').innerHTML='Melhor faixa: <b>'+brl(Math.round(v.price*(1-TIERS[0].p/100)))+' cada</b>.';
      }
    }
  }

  if(LINHA_IDS.length){ sincronizaCarrinho(); }

  /* ---- esporos ---- */
  (function(){
    var cv=root.querySelector('.vf-esp'),cx=cv.getContext('2d'),P=[];
    var calmo=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function dim(){cv.width=root.offsetWidth||innerWidth;cv.height=root.offsetHeight||innerHeight;}
    function seed(){P=[];var n=Math.min(60,Math.round(cv.width/22));
      for(var i=0;i<n;i++)P.push({x:Math.random()*cv.width,y:Math.random()*cv.height,
        r:Math.random()*1.9+.5,v:Math.random()*.22+.05,a:Math.random()*.35+.08,d:Math.random()*6.283});}
    function des(){for(var i=0;i<P.length;i++){var p=P[i];
      cx.beginPath();cx.arc(p.x,p.y,p.r,0,6.283);cx.fillStyle='rgba(216,206,150,'+p.a+')';cx.fill();}}
    function tick(){cx.clearRect(0,0,cv.width,cv.height);
      for(var i=0;i<P.length;i++){var p=P[i];p.y-=p.v;p.d+=.008;p.x+=Math.sin(p.d)*.22;
        if(p.y<-6){p.y=cv.height+6;p.x=Math.random()*cv.width;}}
      des();requestAnimationFrame(tick);}
    dim();seed(); if(calmo){des();}else{tick();}
    addEventListener('resize',function(){dim();seed();if(calmo){cx.clearRect(0,0,cv.width,cv.height);des();}});
  })();

  pinta();
})();
